import { SidePanelPageLayoutTsoPq } from '@components/Grid/GridTsoPq';
import TrendIdentificationContent from './Sections/TrendIdentificationContent';
import TrendIdentificationSidePanel from './Sections/TrendIdentificationSidePanel';

const TrendIdentification = () => {
  return (
    <SidePanelPageLayoutTsoPq sidePanel={<TrendIdentificationSidePanel />} content={<TrendIdentificationContent />} />
  );
};
export default TrendIdentification;
